module.exports = __webpack_public_path__ + "static/media/carousel_chicken_1.4b2eba7d.jpg";